import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import {
  BREADCRUMB_ADDITIONAL_ITEMS,
  BREADCRUMB_BASE_ITEMS,
} from '@alumni_v2/data/breadcrumbData';
import { isNullOrUndefined } from '@common/utils/type';
import Breadcrumb from '@alumni_v2/ui/Breadcrumb';

export default function BreadcrumbContainer() {
  const location = useLocation();
  const { pathname } = location;

  const breadcrumbItems = useMemo(() => {
    let updatedBreadcrumbItems = BREADCRUMB_BASE_ITEMS;
    const pageKey = pathname.split('/')[1];
    const pageSpecificBreadcrumb = BREADCRUMB_ADDITIONAL_ITEMS[pageKey];
    if (!isNullOrUndefined(pageSpecificBreadcrumb)) {
      updatedBreadcrumbItems = {
        ...updatedBreadcrumbItems,
        [pageKey]: pageSpecificBreadcrumb,
      };
    }

    return Object.values(updatedBreadcrumbItems);
  }, [pathname]);

  return (
    <Breadcrumb
      breadcrumbItems={breadcrumbItems}
    />
  );
}
